<template>
  <div id="nav-box" :style="buttons_nav.styleTplBox">
    <svg id="Capa_1" class="button-prev" :style="buttons_nav.styleBPrev" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" x="0px" y="0px" viewBox="0 0 491.1 491.1" xml:space="preserve" @click="scroll_nav('prev')">
      <path d="M379.25,282.85l-192.8,192.8c-20.6,20.6-54,20.6-74.6,0s-20.6-54,0-74.6l155.5-155.5l-155.5-155.5c-20.6-20.6-20.6-54,0-74.6s54-20.6,74.6,0l192.8,192.8C399.85,228.85,399.85,262.25,379.25,282.85z" />
    </svg>
    <div class="nav-box" :style="buttons_nav.styleNavBox">
      <ul :style="buttons_nav.styleUlNav">
        <li v-for="(the_path, the_mod) in array_mod" :id="the_mod" :key="the_mod" :class="[mode == the_mod ? activeClass : '', boxClass]" :title="$t(the_path[2])" @click="change_mode(the_path[0], the_mod)">
          <svg class="box-app-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path :d="the_path[1]" /></svg>
          <span v-if="the_mod == 'chat'" class="box-app-green-button"></span>
        </li>
      </ul>
    </div>
    <svg v-if="Object.keys(this.array_mod).length > 6" id="Capa_1" class="button-next" :style="buttons_nav.styleBNext" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" x="0px" y="0px" viewBox="0 0 491.1 491.1" xml:space="preserve" @click="scroll_nav('next')">
      <path d="M379.25,282.85l-192.8,192.8c-20.6,20.6-54,20.6-74.6,0s-20.6-54,0-74.6l155.5-155.5l-155.5-155.5c-20.6-20.6-20.6-54,0-74.6s54-20.6,74.6,0l192.8,192.8C399.85,228.85,399.85,262.25,379.25,282.85z" />
    </svg>
    <!-- <span id="poweredby" ref="poweredby" v-bind:style="buttons_nav.stylePBC">Powered by <a href="https://cleed.ai/" target="_BLANK" style="font-style: italic;">Cleed.ai</a></span> -->
  </div>
</template>

<script>
    import specs from "@/specs";
    import utils from '../utils';

    export default {
        name: 'NavBox',
        data() {
            return {
                admin_avatar: specs._IMG_AVATAR,
                boxClass: "box-app",
                activeClass: 'active',
                array_mod: 
                    (this.$store.state.config.details.module) ? this.$store.state.config.details.module :
                    { "chat": "M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3M17,12V10H15V12H17M13,12V10H11V12H13M9,12V10H7V12H9Z" },
            };
        },
        computed: {
            mode () {
                const data = this.$store.state.navigation.mode;
                
                if(data == 'chat'){ // Changement particulier pour le mode chat
                    this.buttons_nav.styleTplBox.height = "30%";
                    this.buttons_nav.styleNavBox.marginTop = "-7px"; 
                    this.buttons_nav.stylePBC.bottom = "80px";
                } else if (data != 'chat'){ // Reset du changement particulier pour les autres modes
                    this.reset_chatMode();
                }
                
                this.auto_scroll_nav();
                return data;
            },
            buttons_nav () {
                const data = this.$store.state.navigation.buttons_nav;
                return data;
            }
        },
        mounted() {
            this.auto_scroll_nav();
        },
        methods: {
            change_mode(text = null, mode) { // le 'text' correspond au message envoyÃ© en mÃªme temps que l'on clique sur le bouton
                this.$eb.emit('BoxSwitchMode', {text, mode}); // Changement du mode
                this.$store.state.config.appIsVisible = false; // NÃ©cessaire pour le changement en mode chat

                if (mode == '3d_mode') {
                    this.$store.state.session_navigation.modle3D = true;
                } else if (mode == 'virtual_t_on_mode') {
                    this.$store.state.session_navigation.virtual = true;
                } else {
                    this.$store.state.session_navigation.modle3D = false;
                    this.$store.state.session_navigation.virtual = false;

                }
                setTimeout(() => {utils.scrollDown()}, 100)
            },
            scroll_nav(text) { // Scroll de la navbar
                if (text == "prev") { // Retour en premiÃ¨re vue
                    if (Object.keys(this.array_mod).length <= 6){
                        this.buttons_nav.styleUlNav.marginLeft = "auto";
                    } else {
                        this.buttons_nav.styleUlNav.marginLeft = "0px";
                    }
                    
                    this.buttons_nav.styleBPrev.cursor = "not-allowed";
                    this.buttons_nav.styleBPrev.visibility = "hidden";

                    this.buttons_nav.styleBNext.cursor = "pointer";
                    this.buttons_nav.styleBNext.visibility = "visible";
                } else if (text == "next") { // Direction la seconde vue
                    if (Object.keys(this.array_mod).length > 6){
                        let max_scroll = -55.5 * (Object.keys(this.array_mod).length-6)
                        this.buttons_nav.styleUlNav.marginLeft = max_scroll + "px";
                    }

                    this.buttons_nav.styleBPrev.cursor = "pointer";
                    this.buttons_nav.styleBPrev.visibility = "visible";
                    
                    this.buttons_nav.styleBNext.cursor = "not-allowed";
                    this.buttons_nav.styleBNext.visibility = "hidden";
                }
            },
            reset_chatMode() { // Reset pour le mode chat
                this.buttons_nav.styleTplBox.height = "auto";
                this.buttons_nav.styleNavBox.marginTop = "-7px";
                this.buttons_nav.stylePBC.bottom = "15px";
            },
            auto_scroll_nav(){
                // Si le mode se trouve sur la seconde partie de la navbar, le scroll est automatique
                let secondView = ["product_s_mode", "search", "visual_s_mode", "3d_mode", "size_mode", "virtual_t_on_mode"]
                if(secondView.includes(this.$store.state.navigation.mode) && Object.keys(this.array_mod).length > 6 && Object.keys(this.array_mod).includes(this.$store.state.navigation.mode)){
                    this.scroll_nav("next");
                } else {
                    this.scroll_nav("prev");
                }
            }
        }
    }
</script>